import { snakeCase } from 'lodash';

export const capitalizeFirstLetter = (word: string): string =>
  `${word[0]?.toUpperCase()}${word.slice(1)}`;

export const capitalizeFirstLetterOfEachWord = (word: string): string =>
  word
    .split('-')
    .map((wordValue) => capitalizeFirstLetter(wordValue))
    .join('-');

export const convertToSnakeCase = (word: string): string =>
  // word.replace(/([A-Z])/g, '_$1').toLowerCase();
  snakeCase(word);

export const convertToCamelCase = (word: string): string =>
  word.replace(/(_\w)/g, (_, letter) => letter.toUpperCase());

export const convertToKebabCase = (word: string): string =>
  word.replace(/([A-Z])/g, '-$1').toLowerCase();
